export enum Mutations {
  SET_TOKEN = 'SET_TOKEN',
  SET_USER = 'SET_USER',
  SET_ROLES = 'SET_ROLES',
  SET_PERMISSIONS = 'SET_PERMISSIONS',
  CHANGE_READY_STATE = 'CHANGE_READY_STATE',
  CHANGE_LEAVE_STATE = 'CHANGE_LEAVE_STATE',
  WEBSOCKET_STATE = 'WEBSOCKET_STATE'
}
